import { useState } from "react";
import { Add, Edit, Delete } from "@mui/icons-material";
import { PageTitle } from "../../layout/PageTitle";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { Button } from "@mui/material";
import { PrintTemplateDialog } from "./PrintTemplateDialog";
import { PrintTemplateDto } from "./types";
import { createAxios } from "../../common/axios";


export function PrintTemplateListPage() {
    const [usePrintTemplateStore] = useState(() => createListStore<PrintTemplateDto>({
        path: "settings/printTemplates",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 120 },
            { column: "name", label: "Name", width: 250 },
        ],
    }));

    const printTemplate = usePrintTemplateStore(p => ({ selectedItem: p.selectedItem }));
    const simpleDialog = useSimpleDialog();
    async function deletePhoneCodes() {
        await simpleDialog.show("Print templates", "Delete selected print template?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`settings/printTemplates/${printTemplate?.selectedItem?.id}`);
            }
            finally {
                usePrintTemplateStore.getState().fetch();
            }
        }));
    }
    const newDialog = useDialog(close => <PrintTemplateDialog close={close} printTemplate={null}
        onChange={() => { usePrintTemplateStore.getState().fetch(); }} />, "lg");
    const editDialog = useDialog(close => <PrintTemplateDialog close={close} printTemplate={printTemplate.selectedItem!}
        onChange={() => { usePrintTemplateStore.getState().fetch(); }} />, "lg");
    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <PageTitle title="Print templates" />
        {renderListStore(usePrintTemplateStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={printTemplate.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={printTemplate.selectedItem == null} title="Delete" onClick={deletePhoneCodes}><Delete /></Button>],
            ]),
        })}
    </>;
}
